import React, {useContext} from 'react';
import {employeesTest} from "../../helpers/employees-test";
import Employee from "./Templates/Employee";
import {FloatContainerContext} from "../../contexts/contexts";

const FloatEmployeeList = () => {
  const {setActive} = useContext(FloatContainerContext)

  return (
    <div className="float-container s-column s-flex-gap-12px" onClick={() => setActive(false)}>
      {employeesTest.map(employee => (
        <div className="normal-radius s-px-8px s-py-4px hover-change cursor-pointer">
          <Employee employee={employee} />
        </div>
      ))}
    </div>
  );
};

export default FloatEmployeeList;
